const state = {
  talents: [],
  totalTalent: 0,
  talentsCategory: [],
  listTalentCity: [],
  listTalentNeighborhood: [],
  talentProfileVideo: {},
  talentsAlert: [],
  totalAlertTalents: 0,
  talentAlertSettings: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/browse-talent/state.js